import React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    enterDelay={500}
    leaveDelay={200}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
    '& .MuiTypography-root': {
      display: 'inline-block',
      margin: '0.2em 0.4em 0 0.4em',
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}))

export const tooltipContent = (text, icon) => (
  <React.Fragment>
    {Boolean(icon) && icon}
    <Typography variant='caption' component='div' color='inherit'>
      {text}
    </Typography>
  </React.Fragment>
)

// export default function LightTooltip
